import React from 'react';
import {
  createMuiTheme,
  MuiThemeProvider,
  CssBaseline,
} from '@material-ui/core';
import Header from './layout/Header';
import Main from './layout/Main';
import Footer from './layout/Footer';
import './App.css';

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#505356',
      main: '#25292c',
      dark: '#191c1e',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ffa533',
      main: '#ff8f00',
      dark: '#b26400',
      contrastText: '#fff',
    },
  },
  typography: {
    useNextVariants: true,
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      'Noto Sans',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    h1: {
      fontFamily: 'Open Sans',
      color: 'white',
      margin: '50px 0',
      textAlign: 'center',
      fontSize: '2.5rem',
      textShadow: '0 2px 0 rgba(0, 0, 0, 0.25)',
    },
  },
  overrides: {
    MuiStepIcon: {
      root: {
        '&$active': {
          color: '#ff8f00 !important',
        },
        '&$completed': {
          color: '#ff8f00 !important',
        },
      },
    },
  },
});

const App = function app() {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Header />
      <Main />
      <Footer />
    </MuiThemeProvider>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js